export default class EmailAssetService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  get uploadUrl() {
    return `${this.baseUrl}/emailAsset`
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUrl}/emailAsset`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    if (!response.ok) {
      return []
    }

    return await response.json()
  }

  async importDefaults(options) {
    const response = await fetch(`${this.baseUrl}/emailAsset/import-defaults`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'POST'
    })

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`)
    }

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUrl}/emailAsset/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    if (response.status === 409) {
      const body = await response.json()
      throw new Error(body.message)
    }

    return response.ok
  }
}
